<template>
    <div>
        <pre v-if="viewMode == 0">
            <div v-html="syntaxHighlight(format())"></div>
        </pre>
        <textarea 
            v-else
            class="form-control form-control-sm" 
            rows="3"
            :disabled="viewMode === 2 ? true : false">{{format()}}</textarea>
    </div>
</template>

<script>

export default {
  name: 'JsonViewer',
  props: {
      value: [Object, Array],
      viewMode: {
          type: Number,
          default: 0,
          validator: (prop) => [
              0,
              1,
              2,
          ].includes(prop)
      }
  },
  data: () => {
    return {
      
    }
  },
  computed: {
    
  },
  methods: {
      format() {
          try {
              return JSON.stringify(this.value, undefined, 4)
          } catch (err) {
              console.log(err)
              return null
          }
      },
      syntaxHighlight(json) {
          json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
          return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
              var cls = 'number';
              if (/^"/.test(match)) {
                  if (/:$/.test(match)) {
                      cls = 'key';
                  } else {
                      cls = 'string';
                  }
              } else if (/true|false/.test(match)) {
                  cls = 'boolean';
              } else if (/null/.test(match)) {
                  cls = 'null';
              }
              return '<span class="' + cls + '">' + match + '</span>';
          });
      }
  }
}

</script>

<style scoped>
    pre {
        outline: 1px solid #ccc;
        padding: 5px;
        margin: 5px;
    }

    .string {
        color: green;
    }

    .number {
        color: darkorange;
    }

    .boolean {
        color: blue;
    }

    .null {
        color: magenta;
    }

    .key {
        color: red;
    }
</style>
